import routes from "constants/routes";

export const getJumpingPath = (stationId?: string): string => {
  return `${routes.JUMPING}?id=${stationId || ""}`;
};
